import React from "react";
import "../../../assets/css/scss/section/_profileTabOverview.scss";
import { Image } from "react-bootstrap";
import "../../../assets/css/scss/component/button/_dottedPlainButton.scss";
import PlayerOtherTable from "../../table/playerOtherTable";

export default function ProfileOverviewSection(props: any) {
    console.log("overview", props)
    return (
        <div className="player-profile-overview">
            <div className="theme-bg-white previous-game player-profile-overview-detail">
                {/* <div className="dotted-btn-wrapper">
                    <h3 className="dotted-btn h4 mb-0">Previous Game</h3>
                </div> */}
                <div className="text-gray p-4">
                    {props?.data || ""}
                </div>
                {/* <div className="final-match d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center">
                        <span className="h4 bold mb-0 text-gray">RED SOX</span>
                        <Image src="/assets/images/red.png" alt="RED SOX" fluid />
                        <span className="h2 bold mb-0 text-gray">7</span>
                    </div>
                    <h4 className="font-semibold text-gray mb-0">FINAL</h4>
                    <div className="d-flex align-items-center">
                        <span className="h2 bold mb-0 text-gray score">5</span>
                        <Image src="/assets/images/houston.png" alt="HOUSTON ASTROS" fluid />
                        <span className="h4 bold mb-0 text-gray score-country">
                            HOUSTON ASTROS
                        </span>
                    </div>
                </div>
                <div className="season-stats">
                    <div className="season-table">
                        <div className="season-title">
                            <h4 className="bold mb-0">2021 SEASON STATS</h4>
                        </div>
                        <div className="season-detail">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <h4 className="h6 mb-3">AVG</h4>
                                    <h5 className="h4 mb-3">.470</h5>
                                    <h6 className="h5">
                                        2<sup>nd</sup>
                                    </h6>
                                </div>
                                <div>
                                    <h4 className="h6 mb-3">HR</h4>
                                    <h5 className="h4 mb-3">45</h5>
                                    <h6 className="h5">
                                        Tied-44<sup>th</sup>
                                    </h6>
                                </div>
                                <div>
                                    <h4 className="h6 mb-3">RBI</h4>
                                    <h5 className="h4 mb-3">95</h5>
                                    <h6 className="h5">
                                        31<sup>st</sup>
                                    </h6>
                                </div>
                                <div>
                                    <h4 className="h6 mb-3">OPS</h4>
                                    <h5 className="h4 mb-3">.999</h5>
                                    <h6 className="h5">
                                        3<sup>rd</sup>
                                    </h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <PlayerOtherTable /> */}
            </div>
            {/* <div className="theme-bg-white recent-game player-profile-overview-detail">
                <div className="dotted-btn-wrapper">
                    <h3 className="dotted-btn h4 mb-0">Recent Games</h3>
                </div>
                <PlayerOtherTable />
            </div>
            <div className="theme-bg-white batting-game player-profile-overview-detail">
                <div className="dotted-btn-wrapper">
                    <h3 className="dotted-btn h4 mb-0">2021 Bating</h3>
                </div>
                <PlayerOtherTable />
            </div> */}
        </div>
    );
}
